// region External libraries
import { useQuery } from "@apollo/client";
import { useMsal } from "@azure/msal-react";
// endregion External libraries
// region Store
import {
  ANNOUNCEMENTS_MANAGE,
  myStaffPermissionsQuery,
  TMyStaffPermissionsQuery
} from "src/store/graphql/groups/announcement/query.graphql";
// endregion Store

// LEGACY MIGRATION (temporary) — remove with pages/LegacyMigration.
const LEGACY_MIGRATION = "LEGACY_MIGRATION";

export interface StaffPermissionsState {
  isAdmin: boolean;
  /** True when the user holds the ANNOUNCEMENTS_MANAGE staff permission. */
  canManageAnnouncements: boolean;
  // LEGACY MIGRATION (temporary)
  /** True when the user holds the LEGACY_MIGRATION staff permission. */
  canRunLegacyMigration: boolean;
  loading: boolean;
  error: boolean;
  refetch: () => void;
}

/**
 * The current user's internal staff permissions. Only admins can hold one,
 * so the query is skipped for everyone else. The sidebar entry and the
 * notifications admin page share this single rule (and Apollo cache entry).
 */
export const useStaffPermissions = (): StaffPermissionsState => {

  const { instance } = useMsal();
  const isAdmin = Boolean(instance.getActiveAccount()?.idTokenClaims?.extension_Admin);

  const { data, loading, error, refetch } = useQuery<TMyStaffPermissionsQuery>(myStaffPermissionsQuery, {
    skip: !isAdmin
  });

  const permissions = data?.announcement?.getMyStaffPermissions ?? [];

  return {
    isAdmin,
    canManageAnnouncements: permissions.includes(ANNOUNCEMENTS_MANAGE),
    // LEGACY MIGRATION (temporary)
    canRunLegacyMigration: permissions.includes(LEGACY_MIGRATION),
    loading: isAdmin && loading,
    error: Boolean(error),
    refetch: () => { refetch(); }
  };
};
